import React from 'react';
import { Grid } from '@mui/material';
import AppLayout from '../../layout/app.layout';
import Counters from '../../components/reports/counters.component';
import PAGE_TITLE_LIST from '../../config/page-title.config';
import UserLocationsHeatmap from '../../components/reports/user-locations-heatmap.component';
import WatchedSessionsChart from '../../components/reports/watched-sessions-chart.component';
import PieChart from '../../components/reports/piechart.component';

const DashboardView = () => {
  const pageTitle = PAGE_TITLE_LIST.OVERVIEW_DASHBOARD;

  return (
    <AppLayout pageTitle={pageTitle}>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={12}>
          <Counters />
        </Grid>

        <Grid item xs={12} sm={12} md={12}>
          <UserLocationsHeatmap />
        </Grid>

        <Grid item xs={12} sm={12} md={6}>
          <WatchedSessionsChart />
        </Grid>

        <Grid item xs={12} sm={12} md={6}>
          <PieChart />
        </Grid>
      </Grid>
    </AppLayout>
  );
};

export default DashboardView;
